import { html } from 'lit-element';

import {
  correctnessIndicatorStyles,
  defaultCellFontSize,
  responseStyles,
} from '../cssUtils.js';
import { CustomLitElement } from '../CustomLitElement.js';
import { processEscapedMarkup } from '../utils.js';
import {
  defineElement,
  importMathRendering,
} from '../classroom-tool-extensions/classifier/utils.js';
import { PieMathRenderer } from '../classroom-tool-extensions/common/PieMathRenderer.js';

/**
 * @element extended-text-entry-response
 * @prop {Object} model - The model for the pie
 * @prop {Object} session - The response session
 * @cssprop --pie-live-session-background-color - change the background color
 * @cssprop --pie-live-session-text-color - change the text color
 * @cssprop --pie-live-session-font-family - change the font family
 * @cssprop --pie-live-session-font-size-small - change the font size
 * @cssprop --pie-live-session-response-height - change the height (must be valid, eg: 100px, 10em )
 * @cssprop --pie-live-session-response-width - change the width (must be valid, eg: 100px, 10em )
 */
export class ExtendedTextEntryResponse extends CustomLitElement {
  static get properties() {
    return {
      model: { type: Object, attribute: false },
      session: { type: Array, attribute: false },
    };
  }

  createRenderRoot() {
    return this;
  }

  updated(_changedProperties) {
    super.updated(_changedProperties);

    defineElement('math-rendering-element', PieMathRenderer);

    if (!this.mathRenderingModuleUrlImported) {
      importMathRendering();

      this.mathRenderingModuleUrlImported = true;
    }
  }

  render() {
    const { value } = this.session || {};
    const content = processEscapedMarkup(value || '');

    return html`<style>
        ${correctnessIndicatorStyles}
          ${responseStyles}
          .extended-text-entry.response {
          font-size: var(
            --pie-live-session-font-size-small,
            ${defaultCellFontSize}px
          );
        }
        .extended-text-entry p {
          line-height: 2;
          margin: 0;
        }
        .extended-text-entry .answer {
          border: 1px dotted;
          padding: 0 2px;
        }
      </style>
      <div class="response extended-text-entry">
        <math-rendering-element .label="${content}"></math-rendering-element>
      </div>`;
  }
}

export default ExtendedTextEntryResponse;
